<template>
  <div class="content">
    <div class="md-layout">
      <div class="md-layout-item md-medium-size-100 md-size-75">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>{{ userIcon }}</md-icon>
            </div>
          </md-card-header>

          <md-card-content>
            <form class="form-horizontal" action method="post">
              <div class="md-layout">
                <label class="md-layout-item md-size-5 md-form-label">
                  Email Adress
                </label>
                <div class="md-layout-item">
                  <md-field>
                    <md-input
                      v-model="form.emailAddress"
                      type="email"
                    ></md-input>
                  </md-field>
                </div>
              </div>
              <div class="md-layout">
                <label class="md-layout-item md-size-5 md-form-label">
                  Roles
                </label>
                <div class="md-layout-item">
                  <md-checkbox v-model="form.calmRoles" :value="1"
                    >Admin</md-checkbox
                  >
                  <md-checkbox v-model="form.calmRoles" :value="2"
                    >Consultant</md-checkbox
                  >
                  <md-checkbox v-model="form.calmRoles" :value="3"
                    >Read-Only</md-checkbox
                  >
                  <md-checkbox v-model="form.calmRoles" :value="4"
                    >Manager</md-checkbox
                  >
                </div>
              </div>
            </form>
          </md-card-content>

          <md-card-actions md-alignment="right">
            <md-button
              native-type="submit"
              @click.native.prevent="onSubmit"
              class="md-success md-sm"
              :disabled="hasSubmit"
              ><md-icon class="material-icons">check</md-icon>Submit</md-button
            >
            <md-button class="md-danger md-sm" @click="onCancel"
              ><md-icon class="material-icons">close</md-icon>Cancel</md-button
            >
          </md-card-actions>
        </md-card>
      </div>
      <div class="md-layout-item md-medium-size-100 md-size-25"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      userIcon: "user/icon"
    })
  },
  data() {
    return {
      hasSubmit: false,
      form: {
        emailAddress: undefined,
        calmRoles: []
      }
    };
  },
  methods: {
    onCancel() {
      this.hasSubmit = false;
      this.$router.go(-1);
    },
    onSubmit() {
      this.hasSubmit = true;
      this.$store
        .dispatch("user/createUser", {
          user: this.form
        })
        .then(() => {
          this.$router.push({
            name: "Users"
          });
        })
        .catch(error => {
          let errors = [];
          if (error.response.status === 400) {
            // handle validation error
            if (error.response.data.errors != undefined) {
              let validationErrorDictionary = error.response.data.errors;
              for (var fieldName in validationErrorDictionary) {
                if (validationErrorDictionary.hasOwnProperty(fieldName)) {
                  errors.push("- " + validationErrorDictionary[fieldName]);
                }
              }
            } else {
              errors.push(error.response.data);
            }
          } else {
            errors.push("something went wrong!");
          }
          this.hasSubmit = false;
          this.$store.dispatch("SHOW_ERROR_ALERT", errors);
        });
    }
  }
};
</script>

<style></style>
